/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum QueryResponseSubTypeEnum {
    CSRNOTE = 'csrnote',
    SUPPRESSED = 'suppressed',
    ATTACHMENT = 'attachment',
    RESPONSE = 'response',
    CLARIFY = 'clarify',
    CLINICAL = 'clinical',
    SALUTATION = 'salutation',
}